/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy } from 'react';
import { Row, Col } from 'antd';
import { withTranslation } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import SvgIcon from '../../common/SvgIcon';
import { StyleSheet } from 'react-native';

import * as S from './styles';

const is = require('is_js');

const Button = lazy(() => import('../common/Button'));

const MiddleBlock = ({
  title,
  content,
  button,
  onClick,
  t,
  id,
  section,
  scrollTo,
  link,
  color,
  secondaryColor,
  onFocusColor,
  titleStyle,
  contentStyle,
  buttonPrimaryColor,
  buttonSecondaryColor,
  buttonFocusColor,
}) => {
  const history = useHistory();

  const onScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };
  const _renderContent = () => {
    let _res = [];
    if (is.array(content)) {
      content.forEach((item, id) => {
        _res.push(
          <S.Content key={id} style={contentStyle}>
            {t(item)}
          </S.Content>
        );
      });
    } else if (is.string(content)) {
      _res.push(<S.Content style={contentStyle}>{t(content)}</S.Content>);
    }
    return _res;
  };

  const _handleButtonClick = (id: any) => {
    if (scrollTo) {
      scrollTo(scrollTo);
    }
    if (link && is.url(link)) {
      window.open(link, '_blank');
    }
    if (link && !is.url(link)) {
      let base_url = window.location.origin;
      window.open(`${base_url}${link}`, '_self');
    }
    if (onClick) {
      onClick('contentBlock', id);
    }
  };

  return (
    <S.MiddleBlock id={id}>
      <Row type='flex' justify='center' align='middle'>
        <Fade bottom>
          <S.ContentWrapper>
            <Col lg={24} md={24} sm={24} xs={24}>
              <h3 style={titleStyle}>{t(title)}</h3>
              {_renderContent()}
              <S.ServiceWrapper>
                <Row type='flex' justify='space-between'>
                  {section &&
                    typeof section === 'object' &&
                    section.map((item, id) => {
                      return (
                        <Col key={id} span={11}>
                          {/* <SvgIcon
                                                        src={item.icon}
                                                        width="60px"
                                                        height="60px"
                                                    /> */}
                          <Image
                            alt='Vantr'
                            src={item?.icon}
                            width={'60px'}
                            height={'auto'}
                            preview={false}
                          />
                          <S.MinTitle style={item?.titleStyle}>
                            {t(item.title)}
                          </S.MinTitle>
                          <S.MinPara style={item?.contentStyle}>
                            {t(item.content)}
                          </S.MinPara>
                        </Col>
                      );
                    })}
                </Row>
              </S.ServiceWrapper>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {button ? (
                  <Nav.Link
                    href={link}
                    //   style={StyleSheet.flatten([
                    //       styles.buttonStyle,

                    //   ])}
                    style={{ width: '180px' }}
                  >
                    <Button
                      color={buttonPrimaryColor ?? color}
                      secondaryColor={buttonSecondaryColor ?? secondaryColor}
                      onFocusColor={buttonFocusColor ?? onFocusColor}
                      onClick={_handleButtonClick.bind(null, id)}
                    >
                      {t(button)}
                    </Button>
                    {/* {t(button)} */}
                  </Nav.Link>
                ) : (
                  ''
                )}
              </div>
            </Col>
          </S.ContentWrapper>
        </Fade>
      </Row>
    </S.MiddleBlock>
  );
};

export default withTranslation()(MiddleBlock);
const styles = StyleSheet.create({
  buttonStyle: {
    backgroundColor: '#2664f5',
    color: '#fff',
    fontSize: 18,
    textAlign: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: 130,
    height: 45,
    borderRadius: 5,
  },
});
